<template>
  <button
    type="button"
    class="inline-flex items-center bg-transparent border-0 p-0 font-medium uppercase tracking-wider text-gray-500 hover:text-gray-900 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500"
    @click="switchOrder"
  >
    <span class="my-auto">{{ title }}</span>
    <span
      class="my-auto"
      v-if="
        !effectiveOrdering ||
        (effectiveOrdering !== param && effectiveOrdering !== `-${param}`)
      "
    >
      <SelectorIcon class="h-4" />
    </span>
    <span class="my-auto" v-else-if="effectiveOrdering === `-${param}`">
      <ChevronDownIcon class="h-4" />
    </span>
    <span class="my-auto" v-else-if="effectiveOrdering === param">
      <ChevronUpIcon class="h-4" />
    </span>
  </button>
</template>

<script>
import { ref } from "@vue/reactivity";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  SelectorIcon,
} from "@heroicons/vue/solid";

export default {
  name: "FilterableHeaderCell",
  components: {
    ChevronDownIcon,
    ChevronUpIcon,
    SelectorIcon,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    param: {
      type: String,
      required: false,
      default: "",
    },
    // Optional: when provided, this becomes the single source of truth for
    // the sort indicator (e.g. a parent tracking one shared `ordering`
    // value across columns). When omitted, the component falls back to its
    // own local state, so existing callers keep working unchanged.
    currentOrdering: {
      type: String,
      default: null,
    },
  },
  setup() {
    const ordering = ref(null);
    return { ordering };
  },
  computed: {
    effectiveOrdering() {
      return this.currentOrdering !== null
        ? this.currentOrdering
        : this.ordering;
    },
  },
  methods: {
    setOrdering(ordering) {
      this.ordering = ordering;
    },
    switchOrder() {
      const current = this.effectiveOrdering;
      let next;
      if (current === this.$props.param) {
        next = `-${this.$props.param}`;
      } else if (current === `-${this.$props.param}`) {
        next = this.currentOrdering !== null ? this.$props.param : null;
      } else {
        next = this.$props.param;
      }
      if (this.currentOrdering === null) {
        this.ordering = next;
      }
      this.$emit("switchOrder", next);
    },
  },
};
</script>
